<script lang="ts">
    import axios from 'axios';
    import Shgrid from '../../components/shgrid/shgrid.svelte';
    import type {Column} from '@/components/shgrid';
    import type {Site} from "@/types/types";
    import {SvelteMap} from "svelte/reactivity";

    type Row = Site;

    type Props = {
        view : string;
        onRowClick?: (row: Row) => void;
        relatedData?: Record<string, any>;
        selectedSites?: SvelteMap<string, string> | undefined;
        onSubmitClick?: () => void;
    };

    let {view, onRowClick, relatedData, selectedSites = $bindable(), onSubmitClick }: Props = $props();
    const getRowLink = (row: Row) => route('sites.show', {site: row.id});
    const includeLink = (view != 'related' && view != 'multi_related');
    let cols = $state<Column<Row>[]>([
        {
            label: 'Name',
            key: 'site_name',
            cellRender: {
                type: 'text',
                label: (row) => row.site_name,
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Customers',
            key: 'customers',
            cellRender: {
                type: 'text',
                label: (row) => row.customers.map((customer) => customer.name).join(", "),
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Address Line One',
            key: 'address_line_one',
            cellRender: {
                type: 'text',
                label: (row) => row.address_line_one,
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'string',
            },
        },
        {
            label: 'Created At',
            key: 'created_at',
            cellRender: {
                type: 'date',
                label: (row) => row.created_at,
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'date',
            },
        },
        {
            label: 'Last Updated',
            key: 'updated_at',
            cellRender: {
                type: 'date',
                label: (row) => row.updated_at,
                ...(includeLink && { link: getRowLink }),
            },
            sortable: true,
            filter: {
                type: 'date',
            },
        }
    ]);
</script>
<div>
    <Shgrid
        fetcher={async ({ limit, offset, filters, sorter }) => {
            if (view === 'relatedList' && relatedData) {
                let relatedColumn = relatedData.column ;
                let record_id = relatedData.record_id;
                filters = { ...filters, [relatedColumn] : record_id };
            }
        const res = await axios.get(route('web-api.Site.index', { limit, offset, filters, sorter }));
        return { data: res.data, error: null };
    }}
        limit={100}
        bind:columns={cols}
        {...(view === 'related' ? { onRowClick } : {})}
        bind:selected={selectedSites}
        {...(view === 'multi_related' ? { onSubmitClick } : {})}
        entityColumn="site_name"
    ></Shgrid>
</div>
